<template>
  <div>
    <div
      style="position: fixed; top: 0; left: 0; right: 0; z-index: 999"
      class="payment"
    >
      <van-nav-bar title="合同详情" @click-left="goBack" left-arrow>
      </van-nav-bar>
    </div>

    <div style="padding-top: 46px">
      <div class="info-title">基本信息（只读）</div>

      <div
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
      >
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">内部合同号</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.bill_no }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">内部状态</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.status_txt }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">合同号</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.contract_numbe }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">合同状态</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.contract_state_txt }}</div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">业务员</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">
              {{ info.staff ? info.staff.name : "" }}
            </div>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">创建时间</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <div class="line-input">{{ info.created_at }}</div>
          </div>
        </div>
      </div>

      <div class="info-title">产品信息和费用</div>

      <div
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
      >
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">模板类型</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <select
              v-model="contract_type"
              style="padding: 0"
              class="line-select"
              disabled
              onfocus="this.blur()"
            >
              <option value="A00001">境内游</option>
              <option value="C00001">出境游</option>
              <option value="F00001">赴台游</option>
              <option value="E00001">代订代办</option>
            </select>
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">线路名称</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="必填"
              v-model="contract_name"
            />
          </div>
        </div>

        <div v-if="contract_type == 'A00001' || contract_type == 'C00001'">
          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">出发日期</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.begin_time_select ? $refs.begin_time_select.dateStr : ''
                "
                @click="$refs.begin_time_select.doSelect()"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">结束日期</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.end_time_select ? $refs.end_time_select.dateStr : ''
                "
                @click="$refs.end_time_select.doSelect()"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">共</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                style=""
                placeholder="必填"
                v-model="contract_days"
                type="number"
              />
              <div class="suffix-wrapper">日</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">饭店住宿</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                style=""
                placeholder="必填"
                v-model="contract_nights"
                type="number"
              />
              <div class="suffix-wrapper">夜</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4"><span class="input-tag">成人</span></div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_adult_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">儿童(不满14)</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_child_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">导游服务费</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_service_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">单房差</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_single_price"
                type="number"
              />

              <div class="suffix-wrapper">元/人</div>
            </div>
          </div>

        </div>

<div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">成人人数</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_adult_count"
                type="number"
              />

              <div class="suffix-wrapper">人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">儿童人数</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_child_count"
                type="number"
              />

              <div class="suffix-wrapper">人</div>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">旅游费用合计</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_price"
                type="number"
              />

              <div class="suffix-wrapper">元</div>
            </div>
          </div>

        </div>

<div v-if="contract_type == 'A00001' || contract_type == 'C00001'">

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">支付方式</span>
            </div>
            <div class="cus-row-col-8 select-line">

              <select
                v-model="contract_payway"
                style="padding: 0"
                class="line-select"
              >

                <option value="2">对公转账</option>
                <option value="3">线上支付</option>
              </select>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">支付时间</span>
            </div>
            <div class="cus-row-col-8 select-line">

              <input
                class="line-input"
                type="text"
                style=""
                placeholder="必填"
                readonly
                onfocus="this.blur()"
                :value="
                  $refs.pay_time_select ? $refs.pay_time_select.dateStr : ''
                "
                @click="$refs.pay_time_select.doSelect()"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">其他约定事项</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_pay_remark"
              />
            </div>
          </div>
          <div style="font-size: 12px; line-height: 18px; opacity: 0.6">
            注：未尽事宜，旅游者和旅行社双方协商一致，可列入补充条款。（如合同空间不够，可另附纸张上传附件）
          </div>
        </div>
      </div>

      <div class="info-title">游客代表和游客信息</div>

      <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
        <div
          v-for="(item, index) in course_data"
          :key="index"
          style="padding-bottom: 24px"
          @click="editPerson(item, index)"
        >
          <div style="position: relative">
            <div style="font-size: 14px; font-weight: bold">
              {{ item.name ? item.name : "??" }}
              <span
                v-if="item.isSigner == '1'"
                style="display: inline-block; margin-left: 6px; padding: 0 6px; line-height: 18px; height: 18px; font-size: 12px; color: #fff; background: #ff5722; border-radius: 9px; vertical-align: middle;"
              >签约人</span>
            </div>
            <div style="font-size: 12px; margin-top: 6px">
              {{ cardtypeTxt(item.cardtype) }}：{{ item.idcard }}
            </div>

            <div
              style="
                position: absolute;
                right: 0;
                font-size: 22px !important;
                top: 50%;
                transform: translateY(-50%);
                color: #1889f9 !important;
              "
            >
              <van-icon
                name="edit"
                style="
                  display: inline-block;
                  vertical-align: middle;
                  font-size: 22px !important;
                  color: #1889f9 !important;
                "
              />
            </div>
          </div>
        </div>

        <a
          style="
            display: inline-block;
            width: 100%;
            border-radius: 0.125rem;
            line-height: 0.7rem;
            font-family: PingFangSC-Regular;
            font-size: 0.3rem;
            color: #1889f9;
            border: 1px solid #9f9f9f;
            text-align: center;
          "
          href="javascript:void(0);"
          v-on:click="addCourse"
          v-bind:class="{ inEdit: !nextStepValid }"
        >
          <van-icon
            name="add-o"
            style="
              display: inline-block;
              margin-right: 6px;
              vertical-align: middle;
            "
          />
          <span style="display: inline-block; vertical-align: middle"
            >添加游客</span
          >
        </a>
      </div>

      <div class="info-title">自愿购物及增加景点活动</div>

      <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
        <div
          v-for="(item, index) in shoppings"
          :key="index"
          style="padding-bottom: 24px"
          @click="editShopping(item, index)"
        >
          <div style="position: relative">
            <div style="font-size: 14px; font-weight: bold">
              {{ item.date || '未设置日期' }} · {{ item.shoppingPlace || '未设置购物地点' }}
            </div>
            <div style="font-size: 12px; margin-top: 6px">
              地点：{{ item.place || '-' }} / 商品：{{ item.goods || '-' }} / 停留：{{ item.stayDuration || '-' }} 分钟
            </div>

            <div
              style="position: absolute; right: 0; font-size: 22px !important; top: 50%; transform: translateY(-50%); color: #1889f9 !important;"
            >
              <van-icon name="edit" style="display: inline-block; vertical-align: middle; font-size: 22px !important; color: #1889f9 !important;" />
            </div>
          </div>
        </div>

        <a
          style="display: inline-block; width: 100%; border-radius: 0.125rem; line-height: 0.7rem; font-family: PingFangSC-Regular; font-size: 0.3rem; color: #1889f9; border: 1px solid #9f9f9f; text-align: center;"
          href="javascript:void(0);"
          v-on:click="addShopping"
          v-bind:class="{ inEdit: !nextStepValid }"
        >
          <van-icon name="add-o" style="display: inline-block; margin-right: 6px; vertical-align: middle;" />
          <span style="display: inline-block; vertical-align: middle">添加购物</span>
        </a>
      </div>

      <div v-if="contract_type == 'E00001'">

        <serviceitem ref="plane" title="机票预定" type="1"> </serviceitem>

        <serviceitem ref="hotel" title="酒店预定" type="2"> </serviceitem>

        <serviceitem ref="car" title="用车服务" type="3"> </serviceitem>

        <serviceitem ref="dao" title="导游服务" type="4"> </serviceitem>

        <serviceitem ref="visa" title="签证服务" type="5"> </serviceitem>

        <serviceitem ref="other" title="其他" type="6"> </serviceitem>

        <serviceitem ref="rule" title="通用条款" type="7"> </serviceitem>

      </div>

      <div class="info-title" v-if="contract_type != 'E00001'">地接社信息（非必填）</div>
      <div
        class="form-info-panel"
        style="padding-left: 0.4rem; text-align: left"
        v-if="contract_type != 'E00001'"
      >
        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">地接社名称</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="请输入地接社名称"
              v-model="local_travel_agency.agency_name"
            />
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">具体地址</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="请输入具体地址"
              v-model="local_travel_agency.agency_address_description"
            />
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">联系人姓名</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="请输入联系人姓名"
              v-model="local_travel_agency.contact_name"
            />
          </div>
        </div>

        <div class="barrie-line"></div>

        <div class="cus-row cus-row-v-m">
          <div class="cus-row-col-4">
            <span class="input-tag">联系人电话</span>
          </div>
          <div class="cus-row-col-8 select-line">
            <input
              class="line-input"
              placeholder="请输入联系人电话"
              v-model="local_travel_agency.contact_phone"
              type="tel"
            />
          </div>
        </div>
      </div>

      <div v-if="contract_type == 'A00001' || contract_type == 'C00001'">
        <div class="info-title">其它约定信息</div>

        <div
          class="form-info-panel"
          style="padding-left: 0.4rem; text-align: left"
        >
          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">意外伤害保险</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_insurance_method"
                style="padding: 0"
                class="line-select"
                placeholder="必选"
              >
                <option value="1">委托购买</option>
                <option value="2">自行购买</option>
              </select>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">最低成团人数</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="必填"
                v-model="contract_group_min_count"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">不成团约定</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_group_way"
                style="padding: 0"
                class="line-select"
                placeholder="必选"
              >

                <option value="1">委托其它旅行社</option>
                <option value="2">延期出团</option>
                <option value="3">改签其他线路出团</option>
                <option value="4">解除合同</option>
              </select>
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">委托社名称</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <input
                class="line-input"
                placeholder="非必填"
                v-model="contract_group_othername"
              />
            </div>
          </div>

          <div class="barrie-line"></div>

          <div class="cus-row cus-row-v-m">
            <div class="cus-row-col-4">
              <span class="input-tag">拼团约定</span>
            </div>
            <div class="cus-row-col-8 select-line">
              <select
                v-model="contract_group_agree"
                style="padding: 0"
                class="line-select"
                placeholder="必填"
              >
                <option value="1">同意</option>
                <option value="2">不同意</option>
              </select>
            </div>
          </div>

        </div>
      </div>

      <div v-if="contract_type == 'A00001' || contract_type == 'C00001'">
        <div class="info-title">行程及附件上传</div>

        <div class="form-info-panel" style="padding: 0.4rem; text-align: left">
          <div v-for="(item, index) in fileList" :key="item" style="padding-bottom: 24px">
            <div style="position: relative">
              <div style="font-size: 14px; font-weight: bold">
                {{ getFileNameFromUrl(item) }}
              </div>
              <div style="font-size: 12px; margin-top: 6px">
                上传类型：{{ isPdfUrl(item) ? "pdf" : "docx" }}
              </div>
              <div style="font-size: 12px; margin-top: 6px">
                <FileSizeCheck :url="item" :limit="8" />
              </div>

              <div
                style="
                  position: absolute;
                  right: 0;
                  font-size: 22px !important;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #1889f9 !important;
                "
                @click.stop="deleteFile(item, index)"
              >
                <van-icon
                  name="delete"
                  style="
                    display: inline-block;
                    vertical-align: middle;
                    font-size: 22px !important;
                    color: #1889f9 !important;
                  "
                />
              </div>
            </div>
          </div>

          <a
            style="
              display: inline-block;
              width: 100%;
              border-radius: 0.125rem;
              line-height: 0.7rem;
              font-family: PingFangSC-Regular;
              font-size: 0.3rem;
              color: #1889f9;
              border: 1px solid #9f9f9f;
              text-align: center;
              position: relative;
            "
            href="javascript:void(0);"
            v-bind:class="{ inEdit: !nextStepValid }"
          >
            <van-icon
              name="add-o"
              style="
                display: inline-block;
                margin-right: 6px;
                vertical-align: middle;
              "
            />
            <span style="display: inline-block; vertical-align: middle"
              >添加文件</span
            >

            <input
              type="file"
              style="
                position: absolute;
                z-index: 999;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                opacity: 0;
              "
              accept="application/pdf,.docx"
              @change="getFile"
              ref="upload"
            />
          </a>
        </div>

        <div
          class="ps-text"
          style="padding: 0.2rem; text-align: left; opacity: 0.7"
        >
          注：只支持.pdf,.docx格式的文件。
        </div>
      </div>

      <div
        class="in-bl-line"
        style="padding: 0 0.5rem; margin-top: 0.5rem;"
        v-if="info.status == 1"
      >
        <a
          class="bt"
          href="javascript:void(0);"
          v-on:click="submitContract"
          v-bind:class="{ inEdit: !nextStepValid }"
          >提交合同</a
        >
      </div>

      <div style="height: 200px;">

      </div>

    </div>

    <CusDatePicker
      ref="begin_time_select"
      v-model="contract_begin_day"
    ></CusDatePicker>
    <CusDatePicker
      ref="end_time_select"
      v-model="contract_end_day"
    ></CusDatePicker>
    <CusDatePicker
      ref="pay_time_select"
      v-model="contract_pay_day"
    ></CusDatePicker>

    <CusDatePicker
      ref="shopping_date_select"
      v-model="current_shopping.date"
    ></CusDatePicker>

    <van-image-preview v-model="show" :images="images" @change="onChange">
    </van-image-preview>

    <div style="position: fixed; bottom: 128px; right: 24px" @click="saveDraft">
      <div
        style="
          background-color: rgb(239, 239, 239);
          width: 40px;
          height: 40px;
          border-radius: 100%;
          position: relative;
        "
      >
        <img
          src="~@/assets/images/save_draft.png"
          class="ab-t-t-x-y"
          style="width: 20px; height: 20px"
        />
      </div>
    </div>

    <div style="position: fixed; bottom: 78px; right: 24px" @click="showMore">
      <div
        style="
          background-color: rgb(239, 239, 239);
          width: 40px;
          height: 40px;
          border-radius: 100%;
          position: relative;
        "
      >
        <img
          src="~@/assets/images/more.png"
          class="ab-t-t-x-y"
          style="width: 20px; height: 20px"
        />
      </div>
    </div>

    <van-popup
      v-model="person_show"
      position="right"
      style="width: 82%; height: 100%; background: #f5f5f5; z-index: 99999"
    >

      <div
        style="
          box-shadow: 0px 2px 5px #eeeeee;
          background: #ffffff;
          margin-top: 2px;
        "
      >
        <van-cell title="" is-link value="关闭" @click="person_show = false" />
      </div>

      <div style="overflow-y: scroll; height: calc(100% - 90px)">
        <div style="padding: 12px">
          <van-form>
            <van-field
              name="checkboxGroup"
              label="姓名"
              v-model="current_person.name"
            >
            </van-field>

            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>证件类型</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">

                  <select
                    v-model="current_person.cardtype"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value="1">身份证</option>
                    <option value="4">护照</option>
                    <option value="6">回乡证</option>
                    <option value="8">其他</option>
                  </select>
                </div>
              </div>
            </div>

            <van-field
              name="checkboxGroup"
              label="证件号"
              v-model="current_person.idcard"
            >
            </van-field>

            <van-field
              name="birthday"
              label="出生日期"
              v-model="current_person.birthday"
              placeholder="非必填(例:19991201)"
              @blur="formatBirthdayInput"
            >
            </van-field>

            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>性别</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <select
                    v-model="current_person.gender"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value=""></option>
                    <option value="男">男</option>
                    <option value="女">女</option>
                  </select>
                </div>
              </div>
            </div>

            <van-field
              name="checkboxGroup"
              label="手机号码"
              v-model="current_person.phone"
            >
            </van-field>

            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>是否儿童</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">

                  <select
                    v-model="current_person.is_child"
                    style="padding: 0"
                    class="line-select"
                  >
                    <option value="1">是</option>
                    <option value="2">否</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>是否签约人</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <select
                    v-model="current_person.isSigner"
                    style="padding: 0"
                    class="line-select"
                    :disabled="person_index === 0"
                  >
                    <option value="1">是</option>
                    <option value="0">否</option>
                  </select>
                </div>
              </div>
            </div>

          </van-form>

          <div style="font-size: 12px;text-align: left;margin-top: 24px;">提示：①如团队签约，名单只需填写一个签约代表，剩余名单以表格形式上传至附件。②第一个用户必须是签约人。③出生日期，只有在委托购买-自动委托的且非身份证证件类型的情况下才需填写。</div>
        </div>
      </div>

      <div style="position: absolute; left: 0; right: 0; bottom: 0">
        <div class="cus-row">
          <div class="cus-row-col-6">
            <van-button
              type="danger"
              block
              style="background: #ffffff; color: #000000; border: none"
              @click="deletePerson"
              >删除</van-button
            >
          </div>
          <div class="cus-row-col-6">
            <van-button type="danger" block @click="choseTemplate"
              >继续
            </van-button>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="shopping_show"
      position="right"
      style="width: 82%; height: 100%; background: #f5f5f5; z-index: 99999"
    >
      <div style="box-shadow: 0px 2px 5px #eeeeee; background: #ffffff; margin-top: 2px;">
        <van-cell title="" is-link value="关闭" @click="shopping_show = false" />
      </div>
      <div style="overflow-y: scroll; height: calc(100% - 90px)">
        <div style="padding: 12px">
          <van-form>
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>日期</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div class="van-field__body">
                  <input
                    class="van-field__control"
                    type="text"
                    readonly
                    :value="$refs.shopping_date_select ? $refs.shopping_date_select.dateStr : (current_shopping.date || '')"
                    @click="$refs.shopping_date_select.doSelect()"
                    placeholder="YYYY-MM-DD"
                  />
                </div>
              </div>
            </div>
            <van-field label="城市/地区" v-model="current_shopping.place" />
            <van-field label="购物场所" v-model="current_shopping.shoppingPlace" />
            <van-field label="主要商品" v-model="current_shopping.goods" />
            <van-field label="停留时长(分钟)" v-model="current_shopping.stayDuration" type="number" />
            <van-field label="备注" v-model="current_shopping.memo" type="textarea" rows="2" />
          </van-form>
        </div>
      </div>
      <div style="position: absolute; left: 0; right: 0; bottom: 0">
        <div class="cus-row">
          <div class="cus-row-col-6">
            <van-button type="danger" block style="background: #ffffff; color: #000000; border: none" @click="deleteShopping">删除</van-button>
          </div>
          <div class="cus-row-col-6">
            <van-button type="danger" block @click="shopping_show = false">完成</van-button>
          </div>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="more_show"
      round="true"
      position="bottom"
      :style="{ 'min-height': '10%' }"
    >
      <div>
        <div class="van-share-sheet__options">
          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="goView"
            v-if="info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="newspaper-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">查看合同</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="refreshStatus"
            v-if="info.contract_state != 3 && info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="replay" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">更新状态</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="resend"
            v-if="[1, 2].indexOf(info.contract_state) != -1 && info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="comment-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">签署短信</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="doCopy"
            v-if="[1, 2].indexOf(info.contract_state) != -1 && info.status != 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="brush-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">复制链接</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="deleteJobDraft"
            v-if="info.status == 1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="delete" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">删除草稿</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="deleteContract"
            v-if="
              info.status != 1 && [1, 2, 3].indexOf(info.contract_state) != -1
            "
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="delete" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">作废合同</span>
          </div>

          <div
            role="button"
            tabindex="0"
            class="van-share-sheet__option"
            @click="invalidateResend"
            v-if="info.status != 1 && [4].indexOf(info.contract_state) != -1"
          >
            <div
              style="
                width: 48px;
                height: 48px;
                border-radius: 100%;
                text-align: center;
                background-color: rgb(242, 243, 245);
                font-size: 26px !important;
                position: relative;
              "
            >
              <div class="ab-t-t-x-y">
                <van-icon name="comment-o" style="font-size: 22px" />
              </div>
            </div>
            <span class="van-share-sheet__name">作废短信</span>
          </div>
        </div>

        <button
          type="button"
          class="van-share-sheet__cancel"
          @click="doShareShowCancel"
        >
          取消
        </button>
      </div>
    </van-popup>

  </div>
</template>

<script>
import common from '../assets/js/common'
import CusDatePicker from "../modules/cus_date_picker";
import { Dialog } from "vant";
import _ from "underscore";
import { Toast } from "vant";
import serviceitem from "../components/serviceitem";
import FileSizeCheck from "../components/FileSizeCheck.vue";
import { getJob, updateJob, saveJobDocument, submitJob, cancelJob, deleteJob, syncJobStatus, resendJob, resendInvalidJob, previewJob, uploadFile } from '../assets/js/api'

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  components: {
    CusDatePicker,
    serviceitem,
    FileSizeCheck,
  },
  data: function () {
    return {
      template_type: "",
      begin_time: "",
      price: "",
      pay_username: "",
      collection_username: "",
      pay_date: "",
      faceImg: "",
      tabIndex: 1,
      list: [],
      list_combine: [],
      more_show: false,
      taxlist: [],
      currentId: "",
      invoFlag: false,
      taxpayer_number: "",
      title: "",
      email: "",
      invoiceType: -1,
      chosenFlag: false,
      fillFlag: false,
      page_list: true,
      checked: false,
      detailFlag: false,
      detailItem: {},
      taxpayer_phone: "",
      taxpayer_bank: "",
      bank_account: "",
      showPicSrc: "",
      shouquanshu: "",
      taxpayer_address: "",
      contract_no: "",
      bank_name: "",
      remark: "",
      nextLock: "",
      show: false,
      person_show: false,

      id: this.$route.query.id,
      info: {},

      contract_type: "",
      contract_begin_day: "",
      contract_end_day: "",
      contract_pay_day: "",
      contract_name: "",

      contract_adult_price: "",
      contract_child_price: "",
      contract_adult_count: "",
      contract_child_count: "",
      contract_price: "",
      contract_pay_remark: "",
      contract_payway: "",

      contract_insurance_method: "",

      contract_group_min_count: "",
      contract_group_way: "",
      contract_group_othername: "",
      contract_group_agree: "",
      contract_dispute_tribunalname: "",
      contract_dispute_way: "",

      contract_days: "",
      contract_nights: "",

      course_data: [],
      person_index: -1,
      current_person: {},
      fileList: [],
      isTestMode: common.isTestMode(),
      shoppings: [],
      shopping_show: false,
      shopping_index: -1,
      current_shopping: {},

      local_travel_agency: {
        agency_name: "",
        agency_address_description: "",
        contact_name: "",
        contact_phone: "",
      },
    };
  },
  methods: {
    deleteContract() {
      Dialog.confirm({
        title: "操作提醒",
        message: "确认要作废当前合同吗?",
      }).then(() => {
        cancelJob(this.id).then((res) => {
          if (res.errcode === 0) {
            common.mAlert(this, "作废成功");
            this.initPage();
          } else {
            common.mAlert(this, res.errmsg || "作废失败");
          }
        });
      });
    },

    deleteJobDraft() {
      Dialog.confirm({
        title: "操作提醒",
        message: "确认要删除当前草稿吗?",
      }).then(() => {
        deleteJob(this.id).then((res) => {
          if (res.errcode === 0) {
            common.mAlert(this, "删除成功");
            this.goBack();
          } else {
            common.mAlert(this, res.errmsg || "删除失败");
          }
        });
      });
    },

    goBack() {
      this.$router.push({ path: "/" });
    },
    invalidateResend() {
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要重发签署短信，点击确认将自动发送？",
      }).then(() => {
        resendInvalidJob(this.id).then((res) => {
          if (res.errcode === 0) {
            common.mAlert(this, "重发短信成功");
          } else {
            common.mAlert(this, res.errmsg || "重发短信失败");
          }
        });
      });
    },
    resend() {
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要重发签署短信？",
      }).then(() => {
        resendJob(this.id).then((res) => {
          if (res.errcode === 0) {
            common.mAlert(this, "重发短信成功");
          } else {
            common.mAlert(this, res.errmsg || "重发短信失败");
          }
        });
      });
    },

    refreshStatus() {
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要手动更新状态？",
      }).then(() => {
        syncJobStatus(this.id).then((res) => {
          if (res.errcode === 0) {
            common.mAlert(this, "更新状态成功");
            this.initPage();
          } else {
            common.mAlert(this, res.errmsg || "更新状态失败");
          }
        });
      });
    },

    doCopy() {
      common.mAlert(this, "复制成功");
      common.copy(this.info.contract_sign_url);
    },

    goView() {
      console.log("查看合同内容");
      window.open(this.info.contract_file_url, "_target");
    },

    showMore() {
      this.more_show = true;
    },
    doShareShowCancel() {
      this.more_show = false;
    },

    deleteFile(item, index) {
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要删除当前文件？",
      }).then(() => {

        this.fileList.splice(index, 1);

      });
    },
    isPdfUrl(url) {

      const pdfPattern = /\.pdf$/i;
      return pdfPattern.test(url);
    },
    getFileNameFromUrl(url) {

      const parsedUrl = new URL(url);

      const pathname = parsedUrl.pathname;
      const fileName = pathname.substring(pathname.lastIndexOf("/") + 1);

      return fileName;
    },
    getFile() {
      const inputFile = this.$refs.upload.files[0];
      if (inputFile) {
        if (
          inputFile.type !==
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&
          inputFile.type !== "application/pdf"
        ) {
          alert("不是有效的docx,pdf文件！");
          return;
        }

        var formData = new FormData();
        formData.append("file", inputFile);

        uploadFile(formData).then((res) => {
            this.$refs.upload.value = ""
            if (res.status === 1) {
              this.fileList.push(common.dynamicHost() + res.data.url)
              return
            }
            alert("异常上传")
          }).catch(() => {
            this.$refs.upload.value = ""
            alert("异常上传")
          })
      } else {
        return;
      }
    },

    beforeRead() {
      return true;
    },
    addPerson: {},

    deletePerson() {
      Dialog.confirm({
        title: "操作提醒",
        message: "是否要删除当前游客？",
      }).then(() => {
        this.person_show = false;

        this.course_data.splice(this.person_index, 1);
        this.person_index = -1;

        if (this.course_data.length > 0) {
          if (typeof this.course_data[0].isSigner === 'undefined') {
            this.$set(this.course_data[0], 'isSigner', '1');
          } else {
            this.course_data[0].isSigner = '1';
          }
        }
      });
    },

    editPerson(item, index) {
      this.person_index = index;
      this.current_person = this.course_data[this.person_index];

      if (this.person_index === 0) {
        this.$set(this.current_person, "isSigner", "1");
      } else if (typeof this.current_person.isSigner === "undefined") {
        this.$set(this.current_person, "isSigner", "0");
      }
      this.person_show = true;
    },

    cardtypeTxt(type) {

      if (type == 1) {
        return "身份证";
      }

      if (type == 4) {
        return "护照";
      }

      if (type == 6) {
        return "回乡证";
      }

      if (type == 8) {
        return "其他";
      }
      return;
    },

    formatBirthdayInput() {
      let value = this.current_person.birthday;
      if (!value) return;

      value = value.trim();

      if (value.includes('-')) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          this.current_person.birthday = value;
        }
        return;
      }

      if (/^\d{8}$/.test(value)) {
        const year = value.substring(0, 4);
        const month = value.substring(4, 6);
        const day = value.substring(6, 8);

        const date = new Date(year + '-' + month + '-' + day);
        if (date.getFullYear() === parseInt(year) &&
            date.getMonth() + 1 === parseInt(month) &&
            date.getDate() === parseInt(day)) {
          this.current_person.birthday = year + '-' + month + '-' + day;
        }
      }
    },

    processBirthdayFormat(data) {
      return data.map(person => {
        const cloned = { ...person };
        if (cloned.birthday) {

          const value = cloned.birthday.toString().trim();
          if (/^\d{8}$/.test(value)) {
            const year = value.substring(0, 4);
            const month = value.substring(4, 6);
            const day = value.substring(6, 8);
            cloned.birthday = year + '-' + month + '-' + day;
          }
        }
        return cloned;
      });
    },

    addCourse() {
      const willBeFirst = this.course_data.length === 0;
      this.course_data.push({

        name: "",
        area: "",
        address: "",
        industry_name: "",
        branch_scheme: "",
        size: "",
        editable: true,
        isSigner: willBeFirst ? "1" : "0",
        gender: "",
      });

      this.person_index = this.course_data.length - 1;
      this.current_person = this.course_data[this.person_index];
      this.person_show = true;
    },

    addShopping() {
      this.shoppings.push({ date: '', place: '', shoppingPlace: '', goods: '', stayDuration: '', memo: '' });
      this.shopping_index = this.shoppings.length - 1;
      this.current_shopping = this.shoppings[this.shopping_index];
      this.shopping_show = true;
    },
    editShopping(item, index) {
      this.shopping_index = index;
      this.current_shopping = this.shoppings[this.shopping_index];
      this.shopping_show = true;
    },
    deleteShopping() {
      if (typeof this.shopping_index === 'number' && this.shopping_index > -1) {
        this.shoppings.splice(this.shopping_index, 1);
      }
      this.shopping_index = -1;
      this.shopping_show = false;
    },

    choseTemplate() {
      this.person_show = false;
    },
    buildJobPayload(courseData) {
      return {
        contract_begin_day: this.contract_begin_day,
        contract_end_day: this.contract_end_day,
        contract_pay_day: this.contract_pay_day,
        contract_name: this.contract_name,
        contract_adult_price: this.contract_adult_price,
        contract_child_price: this.contract_child_price,
        contract_adult_count: this.contract_adult_count,
        contract_child_count: this.contract_child_count,
        contract_price: this.contract_price,
        contract_pay_remark: this.contract_pay_remark,
        contract_payway: this.contract_payway,
        contract_service_price: this.contract_service_price,
        contract_single_price: this.contract_single_price,
        contract_insurance_method: this.contract_insurance_method,
        contract_group_min_count: this.contract_group_min_count,
        contract_group_way: this.contract_group_way,
        contract_group_othername: this.contract_group_othername,
        contract_group_agree: this.contract_group_agree,
        contract_dispute_tribunalname: this.contract_dispute_tribunalname,
        contract_dispute_way: 2,
        contract_days: this.contract_days,
        contract_nights: this.contract_nights,
        contract_person_json: JSON.stringify(courseData),
        contract_person_count: courseData.length,
        contract_main_phone: courseData.length ? courseData[0].phone : "",
        contract_main_name: courseData.length ? courseData[0].name : "",
        contract_attachment: JSON.stringify(this.fileList),
        shoppings: JSON.stringify(this.shoppings),
        contract_plane: this.contract_type != "E00001" ? "" : this.$refs.plane.getData(),
        contract_hotel: this.contract_type != "E00001" ? "" : this.$refs.hotel.getData(),
        contract_car: this.contract_type != "E00001" ? "" : this.$refs.car.getData(),
        contract_dao: this.contract_type != "E00001" ? "" : this.$refs.dao.getData(),
        contract_visa: this.contract_type != "E00001" ? "" : this.$refs.visa.getData(),
        contract_other: this.contract_type != "E00001" ? "" : this.$refs.other.getData(),
        contract_rule: this.contract_type != "E00001" ? "" : this.$refs.rule.getData(),
        local_travel_agency: JSON.stringify(this.local_travel_agency),
      };
    },

    saveDraft() {

      Dialog.confirm({
        title: "操作提醒",
        message: "是否将资料暂存草稿？",
      })
        .then(() => {

          let _self = this;

          for (let i = 0, j = _self.course_data.length; i < j; i++) {
            if (!_self.course_data[i].name) {

              common.mAlert(this, `第${i + 1}个游客姓名不能为空`);
              return false;
            }

            if (!_self.course_data[i].cardtype) {

              common.mAlert(this, `第${i + 1}个游客证件类型不能为空`);
              return false;
            }

            if (!_self.course_data[i].idcard) {

              common.mAlert(this, `第${i + 1}个游客证件号不能为空`);
              return false;
            }

            if (
              _self.course_data[i].cardtype == 1 &&
              !/(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(_self.course_data[i].idcard)
            ) {

              common.mAlert(this, `第${i + 1}个游客身份证号格式异常`);
              return false;
            }

            if (!_self.course_data[i].phone) {

              common.mAlert(this, `第${i + 1}个游客手机号不能为空`);
              return false;
            }

            if (!/^1\d{10}$/.test(_self.course_data[i].phone)) {

              common.mAlert(this, `第${i + 1}个游客手机号格式异常`);
              return;
            }

            if (!_self.course_data[i].is_child) {

              common.mAlert(this, `是否儿童不能为空`);
              return false;
            }

          }

          console.log("游客信息输出");
          console.log(_self.course_data);

          _self.course_data = _self.course_data.map(function(p, idx){
            var cloned = Object.assign({}, p);
            if (idx === 0) {
              cloned.isSigner = '1';
            } else if (typeof cloned.isSigner === 'undefined') {
              cloned.isSigner = '0';
            }
            return cloned;
          });

          _self.course_data = this.processBirthdayFormat(_self.course_data);

          saveJobDocument(this.id, this.buildJobPayload(_self.course_data)).then((res) => {
              if (res.errcode === 0) {
                common.mAlert(this, "暂存草稿成功");
              } else {
                common.mAlert(this, res.errmsg || "暂存草稿失败");
              }
            });
        })
        .catch(() => {

        });
    },

    doPreview() {

      let _self = this;

      if (!_self.contract_name) {
        common.mAlert(this, `线路名称不能为空`);
        return false;
      }

      if (!_self.course_data.length) {
        common.mAlert(this, `至少需要一位游客`);
        return false;
      }

      for (let i = 0, j = _self.course_data.length; i < j; i++) {
        if (!_self.course_data[i].name) {
          common.mAlert(this, `第${i + 1}个游客姓名不能为空`);
          return false;
        }
        if (!_self.course_data[i].cardtype) {
          common.mAlert(this, `第${i + 1}个游客证件类型不能为空`);
          return false;
        }
        if (!_self.course_data[i].idcard) {
          common.mAlert(this, `第${i + 1}个游客证件号不能为空`);
          return false;
        }
        if (
          _self.course_data[i].cardtype == 1 &&
          !/(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(_self.course_data[i].idcard)
        ) {
          common.mAlert(this, `第${i + 1}个游客身份证号格式异常`);
          return false;
        }
        if (!_self.course_data[i].phone) {
          common.mAlert(this, `第${i + 1}个游客手机号不能为空`);
          return false;
        }
        if (!/^1\d{10}$/.test(_self.course_data[i].phone)) {
          common.mAlert(this, `第${i + 1}个游客手机号格式异常`);
          return;
        }
        if (!_self.course_data[i].is_child) {
          common.mAlert(this, `是否儿童不能为空`);
          return false;
        }
      }

      if (this.contract_type == "E00001") {
      } else {
        if (!_self.contract_begin_day) {
          common.mAlert(this, `出发日期不能为空`);
          return false;
        }
        if (!_self.contract_end_day) {
          common.mAlert(this, `结束日期不能为空`);
          return false;
        }
        if (!_self.contract_days) {
          common.mAlert(this, `天数不能为空`);
          return false;
        }
        if (_self.contract_nights === "") {
          common.mAlert(this, `夜晚数不能为空`);
          return false;
        }
        if (!_self.contract_adult_price) {
          common.mAlert(this, `成人价不能为空`);
          return false;
        }
        if (!_self.contract_child_price) {
          common.mAlert(this, `儿童价不能为空`);
          return false;
        }
        if (!_self.contract_service_price) {
          common.mAlert(this, `导游服务费不能为空`);
          return false;
        }
        if (!_self.contract_single_price) {
          common.mAlert(this, `单房差不能为空`);
          return false;
        }
        if (_self.contract_adult_count === "") {
          common.mAlert(this, `成人人数不能为空`);
          return false;
        }
        if (_self.contract_child_count === "") {
          common.mAlert(this, `儿童人数不能为空`);
          return false;
        }
        if (!_self.contract_price) {
          common.mAlert(this, `旅游费用不能为空`);
          return false;
        }
        if (!_self.contract_payway) {
          common.mAlert(this, `支付方式不能为空`);
          return false;
        }
        if (!_self.contract_pay_day) {
          common.mAlert(this, `支付时间不能为空`);
          return false;
        }

        if (!_self.contract_insurance_method) {
          common.mAlert(this, `意外伤害保险不能为空`);
          return false;
        }
        if (_self.contract_group_min_count === "") {
          common.mAlert(this, `最低成团人数不能为空`);
          return false;
        }
        if (!_self.contract_group_way) {
          common.mAlert(this, `不成团约定不能为空`);
          return false;
        }
        if (!_self.contract_group_agree) {
          common.mAlert(this, `拼团约定不能为空`);
          return false;
        }
        if (!_self.fileList.length) {
          common.mAlert(this, `附件不能为空`);
          return false;
        }
      }

      _self.course_data = _self.course_data.map(function(p, idx){
        var cloned = Object.assign({}, p);
        if (idx === 0) {
          cloned.isSigner = '1';
        } else if (typeof cloned.isSigner === 'undefined') {
          cloned.isSigner = '0';
        }
        return cloned;
      });

      _self.course_data = this.processBirthdayFormat(_self.course_data);

      Toast.loading({
        duration: 0,
        mask: true,
        message: "正在生成预览...",
      });

      updateJob(this.id, this.buildJobPayload(_self.course_data))
        .then((res) => {
          if (res.errcode !== 0) {
            Toast.clear();
            common.mAlert(this, res.errmsg || "保存失败");
            return null;
          }
          return previewJob(this.id);
        })
        .then((pRes) => {
          if (!pRes) return;
          Toast.clear();
          if (pRes.errcode === 0) {
            if (pRes.url) {
              window.open(pRes.url, "_blank");
            } else {
              common.mAlert(this, pRes.errmsg || "预览生成成功");
            }
          } else {
            common.mAlert(this, pRes.errmsg || "预览生成失败");
          }
        })
        .catch(() => {
          Toast.clear();
          common.mAlert(this, "服务异常");
        });
    },

    previewContract() {
      this.saveContract(true)
    },

    submitContract(){

      console.log("提交合同")
      this.saveContract(false)
    },

    saveContract(isPreview = false) {

      const confirmText = isPreview
        ? '是否确认要生成合同预览？'
        : '是否确认要提交合同？点确定表示你已仔细核对过填写内容。'

      Dialog.confirm({
        title: "操作提醒",
        message: confirmText,
      })
        .then(() => {

          let _self = this;

          if (!_self.contract_name) {
            common.mAlert(this, `线路名称不能为空`);
            return false;
          }

          if (!_self.course_data.length) {
            common.mAlert(this, `至少需要一位游客`);
            return false;
          }

          for (let i = 0, j = _self.course_data.length; i < j; i++) {
            if (!_self.course_data[i].name) {

              common.mAlert(this, `第${i + 1}个游客姓名不能为空`);
              return false;
            }

            if (!_self.course_data[i].cardtype) {

              common.mAlert(this, `第${i + 1}个游客证件类型不能为空`);
              return false;
            }

            if (!_self.course_data[i].idcard) {

              common.mAlert(this, `第${i + 1}个游客证件号不能为空`);
              return false;
            }

            if (
              _self.course_data[i].cardtype == 1 &&
              !/(^\d{15}$)|(^\d{17}(x|X|\d)$)/.test(_self.course_data[i].idcard)
            ) {

              common.mAlert(this, `第${i + 1}个游客身份证号格式异常`);
              return false;
            }

            if (!_self.course_data[i].phone) {

              common.mAlert(this, `第${i + 1}个游客手机号不能为空`);
              return false;
            }

            if (!/^1\d{10}$/.test(_self.course_data[i].phone)) {

              common.mAlert(this, `第${i + 1}个游客手机号格式异常`);
              return;
            }

            if (!_self.course_data[i].is_child) {

              common.mAlert(this, `是否儿童不能为空`);
              return false;
            }

          }

          if (this.contract_type == "E00001") {
          } else {
            if (!_self.contract_begin_day) {
              common.mAlert(this, `出发日期不能为空`);
              return false;
            }

            if (!_self.contract_end_day) {
              common.mAlert(this, `结束日期不能为空`);
              return false;
            }

            if (!_self.contract_days) {
              common.mAlert(this, `天数不能为空`);
              return false;
            }

            if (_self.contract_nights === "") {
              common.mAlert(this, `夜晚数不能为空`);
              return false;
            }

            if (!_self.contract_adult_price) {
              common.mAlert(this, `成人价不能为空`);
              return false;
            }

            if (!_self.contract_child_price) {
              common.mAlert(this, `儿童价不能为空`);
              return false;
            }

            if (!_self.contract_service_price) {
              common.mAlert(this, `导游服务费不能为空`);
              return false;
            }

            if (!_self.contract_single_price) {
              common.mAlert(this, `单房差不能为空`);
              return false;
            }

            if (_self.contract_adult_count === "") {
              common.mAlert(this, `成人人数不能为空`);
              return false;
            }

            if (_self.contract_child_count === "") {
              common.mAlert(this, `儿童人数不能为空`);
              return false;
            }

            if (!_self.contract_price) {
              common.mAlert(this, `旅游费用不能为空`);
              return false;
            }

            if (!_self.contract_payway) {
              common.mAlert(this, `支付方式不能为空`);
              return false;
            }

            if (!_self.contract_pay_day) {
              common.mAlert(this, `支付时间不能为空`);
              return false;
            }

            console.log("值都保存到这里了");

            if (!_self.contract_insurance_method) {
              common.mAlert(this, `意外伤害保险不能为空`);
              return false;
            }

            if (_self.contract_group_min_count === "") {
              common.mAlert(this, `最低成团人数不能为空`);
              return false;
            }

            if (!_self.contract_group_way) {
              common.mAlert(this, `不成团约定不能为空`);
              return false;
            }

            if (!_self.contract_group_agree) {
              common.mAlert(this, `拼团约定不能为空`);
              return false;
            }

            if (!_self.fileList.length) {
              common.mAlert(this, `附件不能为空`);
              return false;
            }
          }

          _self.course_data = _self.course_data.map(function(p, idx){
            var cloned = Object.assign({}, p);
            if (idx === 0) {
              cloned.isSigner = '1';
            } else if (typeof cloned.isSigner === 'undefined') {
              cloned.isSigner = '0';
            }
            return cloned;
          });

          _self.course_data = this.processBirthdayFormat(_self.course_data);

          Toast.loading({
            duration: 0,
            mask: true,
            message: isPreview ? "预览生成中..." : "合同生成中...",
          });

          const payload = this.buildJobPayload(_self.course_data);
          const finish = (res, successMessage, redirect) => {
            Toast.clear();
            if (res.errcode === 0) {
              if (isPreview && res.url) {
                window.open(res.url, "_blank");
              }
              Dialog.alert({
                title: "提示",
                message: successMessage,
              }).then(() => {
                if (redirect) {
                  this.$router.push({ path: "/" });
                }
              });
            } else {
              common.mAlert(this, res.errmsg || successMessage + "失败");
            }
          };

          if (isPreview) {
            updateJob(this.id, payload)
              .then((res) => {
                if (res.errcode !== 0) {
                  Toast.clear();
                  common.mAlert(this, res.errmsg || "保存失败");
                  return null;
                }
                return previewJob(this.id);
              })
              .then((pRes) => {
                if (!pRes) return;
                finish(pRes, "预览生成成功", false);
              })
              .catch(() => {
                Toast.clear();
                common.mAlert(this, "服务异常");
              });
          } else {
            submitJob(this.id, payload)
              .then((res) => finish(res, "合同生成成功", true))
              .catch(() => {
                Toast.clear();
                common.mAlert(this, "服务异常");
              });
          }
        })
        .catch(() => {
          Toast.clear();

          common.mAlert(this, "服务异常");
        });
    },

    showImage() {
      this.show = true
    },
    closeLayer() {
      this.layerFlag = false;
    },

    uploadImg() {
      this.$refs.filElem.dispatchEvent(new MouseEvent("click"));
    },
    initPage() {
      getJob(this.id).then((res) => {
          if (res.status === 1) {

            let info = res.data;
            this.info = info;

            this.contract_type = info.contract_type;
            this.contract_begin_day = info.contract_begin_day;
            this.contract_end_day = info.contract_end_day;
            this.contract_pay_day = info.contract_pay_day;
            this.contract_name = info.contract_name;

            this.contract_adult_price = info.contract_adult_price;
            this.contract_child_price = info.contract_child_price;
            this.contract_adult_count = info.contract_adult_count;
            this.contract_child_count = info.contract_child_count;
            this.contract_price = info.contract_price;
            this.contract_pay_remark = info.contract_pay_remark;
            this.contract_payway = info.contract_payway;

            this.contract_days = info.contract_days;
            this.contract_nights = info.contract_nights;

            this.contract_service_price = info.contract_service_price;
            this.contract_single_price = info.contract_single_price;

            this.contract_insurance_method = info.contract_insurance_method || "";
            this.contract_group_min_count = info.contract_group_min_count;
            this.contract_group_way = info.contract_group_way;

            this.contract_group_othername = info.contract_group_othername;
            this.contract_group_agree = info.contract_group_agree;
            this.contract_dispute_tribunalname =
              info.contract_dispute_tribunalname;
            this.contract_dispute_way = 2;

            if (this.info.contract_person_json) {
              this.course_data = JSON.parse(this.info.contract_person_json);

              this.course_data = this.course_data.map(function(p, idx){
                var cloned = Object.assign({}, p);
                if (idx === 0) {
                  cloned.isSigner = '1';
                } else if (typeof cloned.isSigner === 'undefined') {
                  cloned.isSigner = '0';
                }
                return cloned;
              });
            }

            if (this.info.contract_attachment) {
              console.log("进来了");
              this.fileList = JSON.parse(this.info.contract_attachment);
            }

            if (this.info.shoppings) {
              try {
                this.shoppings = JSON.parse(this.info.shoppings) || [];
              } catch (e) {
                this.shoppings = [];
              }
            }

            if (this.info.local_travel_agency) {
              try {
                const agency = JSON.parse(this.info.local_travel_agency);
                this.local_travel_agency = {
                  agency_name: agency.agency_name || "",
                  agency_address_description: agency.agency_address_description || "",
                  contact_name: agency.contact_name || "",
                  contact_phone: agency.contact_phone || "",
                };
              } catch (e) {
                this.local_travel_agency = {
                  agency_name: "",
                  agency_address_description: "",
                  contact_name: "",
                  contact_phone: "",
                };
              }
            }

            console.log("输出Info");
            console.log(this.info);

            if (this.contract_type == "E00001") {
              this.$nextTick(() => {
                console.log("触发初始值设置");

                this.$refs.plane.init(this.info.contract_plane);
                this.$refs.hotel.init(this.info.contract_hotel);
                this.$refs.car.init(this.info.contract_car);
                this.$refs.dao.init(this.info.contract_dao);
                this.$refs.visa.init(this.info.contract_visa);
                this.$refs.other.init(this.info.contract_other);
                this.$refs.rule.init(this.info.contract_rule);
              });
            }
          }
        });
    },
  },
  created: function () {

    common.checkToken(this);

    console.log("合同详情", this.id);
    this.initPage();
  },
  mounted() {

  },
  computed: {
    nextStepValid: function () {
      return true;
    },
    facePath: function () {
      return common.dynamicHost() + this.faceImg;
    },
    images: function () {
      return [common.dynamicHost() + this.faceImg];
    },
  },
};
</script>

<style>
html,
body {
  background-color: #f8f8f8 !important;
}

input::-webkit-input-placeholder {
  padding-top: 0;
  line-height: normal;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.inEdit {
  opacity: 0.4;
}

.disableText {
  color: #999999 !important;
}

.in-bl {
  display: inline-block;
}

.common-padding {
  padding: 0 0.625rem;
}
.common-padding2 {
  padding: 0.4rem 0.625rem;
}

.fc-aaaaaa-fs-nor-m {
  font-family: PingFangSC-Medium;
  font-size: 0.4375rem;
  color: #aaaaaa;
  line-height: 0.625rem;
}

.camera_text {
  line-height: 0.4rem;
  font-family: PingFangSC-Regular;
  font-size: 0.3rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #1889f9;
}

.bank-desc {
  font-family: PingFangSC-Regular;
  font-size: 0.438rem;
  color: #111111;
  line-height: 0.625rem;
}

.ps-text {
  font-size: 0.22rem;
  line-height: 0.3rem;
  color: #666666;
}

</style>
